export default "* Rytmepinde\n* Klang\n* Rytme ";